const TREATMENT = 'treatment'
const CONTROL = 'control'

type ExperimentType = {
  [key: string]: string | boolean
}

const valueToLower = (value: string | boolean) => {
  if (typeof value === 'string') {
    return value.toLowerCase()
  }

  return value
}

export const formatExperiments = (experiments: ExperimentType) => {
  if (!experiments) {
    return {}
  }

  const result = {}
  Object.keys(experiments).forEach(value => {
    if (experiments[value] === true || valueToLower(experiments[value]) === TREATMENT) {
      result[value] = TREATMENT
      return
    }

    if (experiments[value] === false || valueToLower(experiments[value]) === CONTROL) {
      result[value] = CONTROL
      return
    }

    result[value] = CONTROL
  })

  return result
}

export default formatExperiments